(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // De knop moet meebewegen met de aantallen op het scherm, niet met de winkelwagen zoals
  // die was toen de pagina rendde. Shopify verwerkt `updates[]` vóór het doorsturen naar
  // checkout, dus zonder deze hertelling reken je af met minder dan het minimum.
  //
  // Zonder JS blijft de Liquid-uitkomst staan: dan klopt de knop bij het laden van de
  // pagina, en corrigeert "Winkelwagen bijwerken" hem alsnog.
  (function () {
    /* ⚠ Afrekenen vanaf deze pagina stuurde de cadeauregels ongewijzigd mee.
     * Het formulier post de nieuwe aantallen én gaat direct door naar de checkout,
     * dus `cadeauRegelsSyncen()` in de la kreeg nooit de kans. Verlaagde iemand van
     * 18 naar 17 en klikte hij Afrekenen, dan ging het cadeau van trede 18 gewoon
     * mee — gratis, zonder dat de drempel gehaald werd. De opruiming verderop wist
     * alleen het cart attribute, niet de regel zelf.
     *
     * Daarom: eerst de aantallen wegschrijven, dan de la laten hersynchroniseren,
     * dan pas doorsturen. `updates` als array houdt de volgorde van `cart.items`
     * aan, precies zoals het formulier zelf zou doen.
     *
     * Gevonden in de tweede Codex-review van 25-08-2026.
     */
    async function afrekenenNaSync(event) {
      const knopNu = document.querySelector('[data-cart-checkout]');
      if (!knopNu || knopNu.dataset.gesynct === '1') return;
      event.preventDefault();
      knopNu.disabled = true;
      try {
        // Als object op key, niet als array. Een array accepteert Shopify alleen
        // als zijn lengte exact gelijk is aan het aantal wagenregels — en de
        // cadeauregel staat niet in dit formulier, dus die lengte klopt nooit.
        // Gemeten: zo'n array wordt stil genegeerd, de aantallen blijven staan.
        const updates = {};
        document.querySelectorAll('input[name^="updates["]').forEach((v) => {
          const key = v.name.slice('updates['.length, -1);
          if (key) updates[key] = Number(v.value) || 0;
        });
        // ⚠ `res.ok` toetsen. Een 422 of 429 is een geslaagde `fetch` — de belofte
        // lost gewoon op — dus zonder deze toets liep de code door naar de
        // cadeau-sync en de redirect terwijl Shopify de óude aantallen hield. De
        // klant ziet dan één wagen en rekent met een andere af, en de opruiming
        // rekent bovendien tegen de verkeerde wagen. Gevonden in de vijfde
        // Codex-review van 25-08-2026.
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!res.ok) throw new Error(`cart/update.js gaf ${res.status}`);
        if (typeof window.smWagenHersynchroniseren === 'function') {
          await window.smWagenHersynchroniseren();
        }
      } catch {
        // ⚠ Fail-closed, en dat is een omkering. Hier stond "doorsturen is beter
        // dan vastlopen"; dat klopt niet op een pad dat een gratis product kan
        // weggeven. Mislukt het bijwerken of de synchronisatie, dan herladen we
        // de wagenpagina: de klant ziet dan wát de server werkelijk heeft en kan
        // opnieuw afrekenen. Doorsturen zou hem laten betalen voor een wagen die
        // hij niet gezien heeft — of een cadeau meegeven dat hij niet verdiende.
        knopNu.disabled = false;
        window.location.assign(window.location.pathname);
        return;
      }
      knopNu.dataset.gesynct = '1';
      window.location.href = '/checkout';
    }
    /* ⚠ Op `submit` en niet op `click`. Een klik op de afrekenknop is maar één
     * manier om dit formulier te versturen: de knop staat als eerste `submit` in
     * het formulier, dus Enter in een aantal-veld verstuurt hem óók — en dan
     * ging de bezoeker rechtstreeks naar /checkout met de nieuwe aantallen én de
     * oude cadeauregel. Precies dezelfde gratis maaltijd als bij de klik, via een
     * andere deur. Gevonden in de tweede Codex-review van 25-08-2026.
     *
     * De bijwerkknop moet er wél gewoon doorheen: die post het formulier en
     * herlaadt de pagina, dat is zijn werk. Een `submitter` van `null` (sommige
     * browsers geven die bij Enter) valt in de afrekentak, want de standaardknop
     * ván dit formulier is de afrekenknop. */
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.querySelector || !form.querySelector('[data-cart-checkout]')) return;
      if (event.submitter && event.submitter.name === 'update') return;
      afrekenenNaSync(event);
    });

    const knop = document.querySelector('[data-cart-checkout]');
    if (!knop) return;
    const minimum = Number(knop.dataset.min || 7);
    const melding = document.querySelector('[data-cart-min]');
    const velden = document.querySelectorAll('input[name^="updates["]');

    function hertel() {
      let maaltijden = 0;
      velden.forEach((veld) => {
        const perStuk = Number(veld.dataset.maaltijden || 0);
        const aantal = Number(veld.value || 0);
        if (perStuk > 0 && aantal > 0) maaltijden += perStuk * aantal;
      });
      const tekort = minimum - maaltijden;
      knop.disabled = tekort > 0;
      knop.setAttribute('aria-disabled', String(tekort > 0));
      if (melding) {
        melding.hidden = tekort <= 0;
        if (tekort > 0) {
          const woord = tekort === 1 ? 'maaltijd' : 'maaltijden';
          melding.textContent = `Nog ${tekort} ${woord} te gaan. Een bestelling begint bij ${minimum} maaltijden.`;
        }
      }
    }

    velden.forEach((veld) => {
      veld.addEventListener('input', hertel);
      veld.addEventListener('change', hertel);
    });
    hertel();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-article"]) return;
  try {
    
  (() => {
    const body = document.querySelector('[data-sm-article-body]');
    const toc = document.querySelector('[data-sm-toc]');

    if (body && toc) {
      const list = toc.querySelector('.art-toc-list');
      const koppen = [...body.querySelectorAll('h2')];
      const min = Number(toc.dataset.min || 3);

      // Onder de drempel blijft de inhoudsopgave verborgen: een lijstje van één
      // regel is ruis, geen navigatie.
      if (koppen.length >= min) {
        const links = koppen.map((kop, i) => {
          if (!kop.id) kop.id = `sectie-${i + 1}`;
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = `#${kop.id}`;
          a.textContent = kop.textContent.trim();
          li.append(a);
          list.append(li);
          return a;
        });

        toc.hidden = false;
        // Op smal scherm staat hij bovenaan de tekst; open zou daar een halve
        // pagina kosten.
        toc.open = !window.matchMedia('(max-width: 980px)').matches;

        const zichtbaar = new Set();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) zichtbaar.add(entry.target.id);
              else zichtbaar.delete(entry.target.id);
            });
            const eerste = koppen.find((kop) => zichtbaar.has(kop.id));
            links.forEach((a) => {
              if (eerste && a.hash === `#${eerste.id}`) a.setAttribute('aria-current', 'true');
              else a.removeAttribute('aria-current');
            });
          },
          { rootMargin: '-80px 0px -70% 0px' }
        );
        koppen.forEach((kop) => observer.observe(kop));
      }
    }

    document.querySelectorAll('[data-sm-copy]').forEach((knop) => {
      const label = knop.querySelector('[data-sm-copy-label]');
      const origineel = label.textContent;
      knop.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          label.textContent = knop.dataset.done;
          setTimeout(() => {
            label.textContent = origineel;
          }, 2000);
        } catch {
          // Clipboard geweigerd (geen https, of gebruiker zei nee) — dan blijft
          // het label staan. Een foutmelding voor "kopieer link" is erger dan
          // niets doen.
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-cart-drawer"]) return;
  try {
    
  // Eén gedelegeerde laag voor alle wagenacties: toevoegen op elke pagina,
  // aantal wijzigen in de drawer en op de kaart, en de drawer openen.
  // Delegeren is hier geen stijlkeuze — de drawerinhoud wordt na elke mutatie
  // vervangen, dus een listener die aan een knop hangt is daarna weg.
  //
  // Alles staat in een IIFE, net als in `cart.liquid`. Shopify plakt het
  // javascript-blok van élke sectie aan elkaar in één bestand met één top-level
  // scope; namen als `root` of `verversen` zijn precies generiek genoeg dat een
  // latere sectie ze opnieuw declareert. Dat is dan geen conflict in deze sectie
  // maar een SyntaxError in het hele gebundelde bestand — waarmee ook de
  // hertelling van de afrekenknop op de wagenpagina stilvalt.
  (function () {
  const SECTIE = 'sm-cart-drawer';

  // Eén vlag voor toevoegen én wijzigen. Zonder gedeelde vlag zit er een gat: de
  // stapknoppen gaan wel op slot, maar een koopknop niet, dus een toevoeging kan
  // over een lopende wijziging heen landen en de drawer met een oudere
  // momentopname overschrijven — inclusief een afrekenknop die openstaat op een
  // wagen die de drempel niet meer haalt.
  let bezig = false;

  // Wagenverzoeken staan achter elkaar in plaats van naast elkaar.
  //
  // Hier stond alleen `bezig` als poort, en een tweede klik werd daarmee
  // gewéigerd in plaats van uitgesteld. Voor de toevoegknop viel dat oordeel
  // vóór `preventDefault()`, dus postte het formulier daarna gewoon native:
  // volledige paginalading en een redirect naar /cart. Gemeten op de preview met
  // drie kaarten vlak na elkaar — twee van de drie kliks navigeerden weg. Dat is
  // precies de storing die de AJAX-route moest voorkomen.
  //
  // `openTaken` en niet een enkele boolean: `bezig` moet aanstaan zolang er
  // íets in de rij zit, niet alleen tijdens de taak die nu loopt. De stepper
  // hieronder leest hem om een klik te laten vallen, en dat oordeel moet ook
  // kloppen als er nog twee toevoegingen wachten.
  let wachtrij = Promise.resolve();
  let openTaken = 0;
  function inWachtrij(taak) {
    openTaken += 1;
    bezig = true;
    // `.then(taak, taak)`: een mislukte taak mag de rij niet laten stilvallen.
    const klaar = wachtrij.then(taak, taak);
    wachtrij = klaar.catch(() => {}).then(() => {
      openTaken -= 1;
      if (openTaken === 0) bezig = false;
    });
    return klaar;
  }

  const root = () => document.querySelector('[data-cart-root]');
  const drawer = () => document.querySelector('[data-cart-drawer]');

  function openen() {
    const d = drawer();
    // Focus wég uit de melding vóór `showModal()`, niet erna. Het dialog onthoudt
    // op dát moment welk element de focus had en zet hem daar bij het sluiten
    // terug. Werd de la geopend vanaf de knop ín de melding, dan is dat element
    // één regel later `display: none` en doet die terugzetstap niets: de focus
    // valt op body en de volgende Tab begint bovenaan de pagina. Precies de
    // storing waar `focusTerug` hieronder voor de steppers voor bestaat.
    // Onvoorwaardelijk verplaatsen als de melding openstaat, niet alleen wanneer
    // de focus er aantoonbaar ín staat. Safari verplaatst de focus namelijk niet
    // naar een <a> bij een klik — zie de comment bij `toastFocusuit` hieronder —
    // dus daar is `activeElement` nog <body> en zou een `contains`-toets nee
    // zeggen terwijl de la wél vanuit de melding geopend wordt. `showModal()`
    // legt dan <body> vast als terugkeerpunt en de focus valt na het sluiten
    // alsnog op body.
    const t = toast();
    if (t && !t.hidden) document.querySelector('[data-cart-link]')?.focus();
    if (d && !d.open) d.showModal();
    // De melding heeft zijn werk gedaan zodra de la opengaat; laten staan zou hem
    // achter de backdrop parkeren en na het sluiten weer tevoorschijn laten komen.
    toastVerbergen();
    feedInhalen();
  }

  // De toevoegmelding bij het wagenicoon. De markup staat in `sm-header.liquid`,
  // want hij moet blijven staan terwijl de drawer dicht is; hier staat alleen het
  // vullen en het wegnemen. Ontbreekt hij — een pagina zonder header — dan doet
  // dit niets en gaat de rest gewoon door.
  const toast = () => document.querySelector('[data-cart-toast]');
  let toastKlok;

  // Kwam de laatste bediening van een toetsenbord? Bepaalt of de melding de focus
  // naar zich toe haalt.
  //
  // Waarom dat onderscheid nodig is: het paneel staat in de header en dus vroeg in
  // de DOM. Wie op een productkaart iets toevoegt en vooruit tabt, komt er nooit
  // meer langs — de bevestiging én de knop erin zijn alleen achteruit bereikbaar.
  // Focus verplaatsen lost dat op, maar mag niet altijd: bij een muisklik zou de
  // focus in het paneel blijven staan, en dan houdt de bestaande focusout-tak de
  // melding open tot de klant ergens anders klikt. Wat een klok van 6 seconden was,
  // wordt dan een paneel dat blijft hangen.
  let viaToetsenbord = false;
  document.addEventListener('pointerdown', () => { viaToetsenbord = false; }, true);
  document.addEventListener('keydown', (e) => {
    // Alleen de toetsen die een knop of formulier bedienen. Tabben alleen is
    // navigeren, geen bediening.
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') viaToetsenbord = true;
  }, true);

  // Escape sluit de melding. Hij hangt op het document en niet op het paneel: bij
  // een muistoevoeging staat de focus nog op de toevoegknop, dus een luisteraar op
  // het paneel zelf zou de toets nooit zien.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const t = toast();
    if (!t || t.hidden) return;
    // Stond de focus in het paneel, dan moet hij ergens heen dat bestaat. `body`
    // is geen plek; de wagenknop is waar het paneel bij hoort en is altijd zichtbaar.
    const focusBinnen = t.contains(document.activeElement);
    toastVerbergen();
    if (focusBinnen) toastFocusTerug();
  });

  // De sluitknop. Gedelegeerd, want het paneel wordt niet opnieuw gerenderd maar de
  // luisteraar mag ook niet per toevoeging opnieuw gebonden worden.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-cart-toast-sluit]')) return;
    toastVerbergen();
    toastFocusTerug();
  });
  // De `focusout`-luisteraar wordt bewaard in plaats van alleen met `once`
  // afgevuurd. Zonder dat blijft hij hangen: staat de focus in het paneel als de
  // klok afloopt, dan wordt hij gewapend, maar sluit de klant het paneel niet en
  // voegt hij iets nieuws toe, dan staat er een verse melding mét een oude
  // luisteraar — en die neemt hem bij de eerstvolgende focuswissel meteen weg.
  // In Safari verplaatst een klik op een knop de focus niet, dus daar is dat een
  // gewone volgorde en geen randgeval.
  let toastFocusuit = null;

  /**
   * Geeft de focus terug aan de wagenknop nadat de melding gesloten is.
   *
   * ⚠ OPEN PUNT, bewust niet verder opgerekt. De code-review merkte terecht op
   * dat de conventionele stand is: terug naar de knop die de melding opriep, niet
   * naar de header. Op een collectiepagina gooit dit een toetsenbordwinkelaar
   * terug naar boven.
   *
   * Twee pogingen daartoe zijn GEMETEN en werkten geen van beide. Het formulier
   * bij de submit vastleggen (de knop zelf kan niet: `toevoegen()` zet hem op
   * `disabled` en dát verplaatst de focus naar `body` vóórdat de melding
   * verschijnt) en daarna zijn submitknop focussen liet de focus op `body`
   * achter — óók met de `focus()` een frame later, ná het `hidden` zetten van het
   * paneel. Beide takken van die functie hadden iets moeten focussen; geen van
   * beide landde. Onopgelost.
   *
   * Wat hieronder staat is de variant die WÉL gemeten werkt. Een werkende
   * eenvoudige stand is beter dan een kapotte betere; wie hem alsnog wil
   * oprekken, begint bij de vraag waaróm die focus niet landt en meet dat vóór
   * hij code toevoegt.
   */
  function toastFocusTerug() {
    document.querySelector('[data-cart-open]')?.focus();
  }

  function toastKlokWissen() {
    clearTimeout(toastKlok);
    const t = toast();
    if (t && toastFocusuit) t.removeEventListener('focusout', toastFocusuit);
    toastFocusuit = null;
  }

  function toastVerbergen() {
    const t = toast();
    if (t) t.hidden = true;
    toastKlokWissen();
  }

  function toastTonen(regel) {
    const t = toast();
    if (!t) return;
    const naam = t.querySelector('[data-cart-toast-naam]');
    // `product_title` is het veld dat /cart/add.js teruggeeft, ook in de
    // `items`-vorm. Ontbreekt het, dan blijft de naamregel leeg en klapt hij via
    // `:empty` weg.
    //
    // ⚠ Sinds de melding het vinkje "Toegevoegd" én de knop kwijt is, blijft er in
    // dat geval alleen een foto, een aantal en een prijs over — nergens meer een
    // woord dat zégt dat er iets is toegevoegd. De aankondiging op
    // `[data-cart-melding]` vangt dat op voor een schermlezer, maar zichtbaar is
    // het een stille kaart. Gemeten: /cart/add.js gaf op alle geteste routes een
    // product_title, dus dit is een randgeval en geen dagelijkse stand.
    if (naam) naam.textContent = (regel && regel.product_title) || '';

    // Prijs, wagenstand en voortgang. Die worden hier NIET uitgerekend: de
    // drawer-sectie is vlak hiervoor door `verversen()` opnieuw gerenderd en
    // draagt exact dezelfde cijfers, in het money_format van de winkel en in de
    // copy van dit thema. Ze hier overtypen zou een tweede bron maken die stil
    // uiteenloopt zodra de staffel of de drempeltekst wijzigt.
    const uitDrawer = (kies) => document.querySelector(kies)?.textContent.trim() || '';

    const prijs = t.querySelector('[data-cart-toast-prijs]');
    // `final_line_price` is de regel inclusief aantal; bij een dubbele toevoeging
    // van hetzelfde gerecht is dat de hele regel en niet alleen wat er net bij
    // kwam. In centen, dus door 100 — het valutateken komt uit de wagen zelf.
    if (prijs) {
      const cent = regel && (regel.final_line_price ?? regel.line_price ?? regel.final_price);
      prijs.textContent = typeof cent === 'number' ? '€' + (cent / 100).toFixed(2).replace('.', ',') : '';
    }

    const stand = t.querySelector('[data-cart-toast-stand]');
    if (stand) {
      const wortel = document.querySelector('[data-cart-root]');
      const aantal = Number(wortel?.dataset.cartCount || 0);
      // `data-cart-totaal` en niet de eerste voetregel: die draagt het subtotaal
      // vóór een wagenbrede korting, en dan noemde de melding een hoger bedrag
      // dan de afrekenknop.
      const totaal = wortel?.dataset.cartTotaal || '';
      // Het woord "totaal" stond hier omdat bij één gerecht regelprijs en
      // wagentotaal hetzelfde bedrag zijn, en twee gelijke bedragen naast elkaar
      // als een fout lezen. Dat geldt nog steeds — maar alleen dán. Vanaf twee
      // artikelen verschillen de bedragen zichtbaar en is het woord ballast op een
      // regel die in één oogopslag gelezen moet worden.
      stand.textContent = aantal
        ? aantal + (aantal === 1 ? ' artikel' : ' artikelen') +
          (totaal ? (aantal === 1 ? ' · totaal ' : ' · ') + totaal : '')
        : '';
    }

    // ⚠ Hier stond de voortgangsregel (maaltijddrempel of verzendstaffel). Die is
    // eruit: exact dezelfde zin staat in de wagenla, en de melding is een
    // bevestiging van één handeling — niet een tweede plek waar de staffel wordt
    // uitgelegd. Het blauwe wash-vlak eronder maakte de melding bovendien bijna
    // twee keer zo hoog voor informatie die je een klik verderop nog een keer ziet.
    // De la blijft de plek waar de staffel woont.

    // Het beeld komt uit dezelfde respons. `image` is de kale CDN-URL; daar een
    // `width` op zetten scheelt een bestand van een megabyte voor een vak van
    // 46px. 138 = 3× 46, voor een scherm op 3x. Markup, CSS en deze breedte
    // moeten hetzelfde vak beschrijven; ze liepen twee keer eerder uiteen. Ontbreekt het beeld, dan haalt `removeAttribute` het `src` weg en
    // klapt het kader via `:not([src])` weg in plaats van leeg te blijven staan.
    const beeld = t.querySelector('[data-cart-toast-beeld]');
    if (beeld) {
      const bron = (regel && (regel.image || regel.featured_image?.url)) || null;
      if (bron) beeld.src = bron + (bron.includes('?') ? '&' : '?') + 'width=138';
      else beeld.removeAttribute('src');
    }

    // Stond de melding er al, dan is `hidden = false` een no-op en speelt de
    // animatie niet opnieuw: naam en foto wisselen dan geruisloos. Nu de drawer
    // niet meer openklapt is dit paneel de énige bevestiging, dus een stille
    // wissel is makkelijk te missen. De animatienaam even weghalen en een reflow
    // forceren start hem opnieuw; `offsetWidth` uitlezen ís die reflow.
    if (!t.hidden) {
      t.style.animation = 'none';
      void t.offsetWidth;
      t.style.animation = '';
    }
    t.hidden = false;

    // Alleen bij een toetsenbordtoevoeging: zie `viaToetsenbord` hierboven. De
    // focus gaat naar het paneel zelf en niet naar de sluitknop — dan leest een
    // schermlezer eerst het label en de inhoud, in plaats van meteen "Melding
    // sluiten" zonder te zeggen wát er gesloten wordt.
    if (viaToetsenbord) t.focus({ preventScroll: true });

    toastKlokWissen();
    toastKlok = setTimeout(() => {
      // Niet wegnemen terwijl de focus erbinnen staat: dan verliest een
      // toetsenbordgebruiker halverwege zijn plek en springt de focus naar body.
      // Wachten tot hij eruit stapt is de enige stand die dat niet doet.
      if (t.contains(document.activeElement)) {
        toastFocusuit = () => { t.hidden = true; toastFocusuit = null; };
        t.addEventListener('focusout', toastFocusuit, { once: true });
        return;
      }
      t.hidden = true;
    }, 6000);
  }

  // Inhaalslag voor de cross-sell-feed; zie punt 4 bij de feed in de Liquid
  // hierboven. De feed staat in een `paginate`-blok, en dat luistert naar `?page`
  // in de URL. Op /collections/x?page=2 rendert hij daardoor uit een tweede pagina
  // die niet bestaat en staat hij leeg. Elke wagenmutatie herstelt dat vanzelf
  // (`sections_url` is `location.pathname`, dus zonder query), maar wie de la
  // opent zónder iets te wijzigen zou een lege feed zien.
  //
  // Het baken zit ín `[data-cart-inner]` en niet erop: `verversen` vervangt de
  // binnenkant, dus het verdwijnt vanzelf zodra de verse sectie binnen is. Een
  // vlag op het element eromheen zou blijven staan en elke opening opnieuw vuren.
  // `bezigInhalen` dekt alleen de tijd dat het verzoek loopt — mislukt het, dan
  // mag een volgende opening het opnieuw proberen.
  let bezigInhalen = false;
  function feedInhalen() {
    if (bezigInhalen) return;
    if (!document.querySelector('[data-feed-vervolg]')) return;
    bezigInhalen = true;
    fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .then((html) => {
        // Nog eens toetsen, en dat is geen dubbelop: deze fetch kan landen ná
        // een wagenmutatie die intussen door de rij liep. Ging er zo'n mutatie
        // doorheen, dan is het baken al weg en zou deze — oudere — momentopname
        // de verse wagen overschrijven. (Hier stond dat `openen()` óók vlak vóór
        // een toevoeging draaide; dat is niet meer zo, maar de toets blijft
        // nodig.)
        if (html && document.querySelector('[data-feed-vervolg]')) verversen(html);
      })
      .catch(() => {})
      .finally(() => {
        bezigInhalen = false;
      });
  }

  // Zet de focus terug op de knop waar hij vandaan kwam. Nodig om twee redenen
  // die allebei op zichzelf al genoeg zijn: het uitschakelen van de knop blurt
  // hem, en de vervanging hieronder gooit hem daarna weg. Zonder dit valt een
  // toetsenbordgebruiker na élke plus terug op het dialog en moet hij opnieuw
  // tabben — per stuk.
  // De zoektocht is begrensd tot de drawerinhoud, en dat is geen detail: dezelfde
  // `data-key` staat óók op de stepper van de productkaart. Een ongebonden
  // querySelector pakt die eerst, en zolang het dialog modaal is, is alles
  // daarbuiten inert — focus() doet dan niets en de focus blijft op body hangen.
  function focusTerug(knop, inDrawer, key, stap) {
    // `stap` is het `data-step`-attribuut van de knop, of de tekst 'veld' voor het
    // invoerveld met het aantal. Sinds 25-08-2026 wordt deze niet meer vanuit de
    // klik aangeroepen maar vanuit `verversen`: de schrijfronde is losgekoppeld
    // van de klik, dus het element waar de focus op stond is dan al vervangen.
    if (!inDrawer) {
      // Buiten de drawer wordt niets vervangen, dus de oorspronkelijke knop
      // bestaat nog — maar bestaan is niet genoeg. Ging het aantal naar nul, dan
      // is de hele stepper op de kaart intussen `display: none` en doet focus()
      // niets; de focus valt dan terug op body en de volgende Tab begint weer
      // bovenaan de pagina. De koopknop staat op diezelfde plek terug.
      if (knop.offsetParent) knop.focus();
      else knop.closest('[data-card-atc]')?.querySelector('[type="submit"]')?.focus();
      return;
    }
    // Of de knop in de drawer stond moet vooraf zijn vastgesteld: ná de
    // vervanging is het oorspronkelijke element losgekoppeld, en dan zegt elke
    // `contains`-toets nee — waarna focus() op een dood element niets doet.
    const inner = document.querySelector('[data-cart-inner]');
    const terug =
      stap === 'veld'
        ? inner.querySelector(`[data-stepper][data-key="${key}"] [data-step-value]`)
        : inner.querySelector(
            `[data-stepper][data-key="${key}"] [data-step="${stap}"]:not([disabled])`
          );
    // Ging het aantal naar nul, dan bestaat die knop niet meer; dan is de
    // sluitknop de eerstvolgende zinnige plek in plaats van helemaal geen focus.
    if (terug) terug.focus();
    else document.querySelector('[data-cart-close]')?.focus();
  }

  // De sectie komt terug als volledige HTML. Alleen de binnenkant wordt
  // vervangen: het dialog-element blijft daardoor staan en dus open.
  // Geeft terug of het gelukt is. Kwam de sectie niet mee, dan toont de drawer de
  // wagen van vóór de wijziging en leest dat als "er is niets gebeurd" — waarna de
  // klant nog een keer drukt. De aanroeper stuurt in dat geval door naar /cart,
  // waar de waarheid staat.
  /* De énige plek die cadeau-attributen naar de wagen schrijft. Ze hangen ook via
   * `form="cd-form"` aan het afrekenformulier, maar dat pad loopt alleen als de klant
   * via de drawer afrekent — niet vanaf /cart en niet met een betaalknop. Deze functie
   * schrijft ze daarom actief weg: bij het laden, na elke verversing, en na een
   * cadeaukeuze. Faalt de POST, dan blijft `cd-form` het vangnet.
   *
   * ⚠ Er stond hier tot 22-08-2026 een tweede schrijver: de `change`-luisteraar op de
   * radio's postte zijn eigen keuze rechtstreeks, buiten `cadeauStand` om. Twee
   * schrijvers en één cache is een gat: na zo'n keuze week de cache af van de wagen,
   * en zakte de klant daarna onder de drempel, dan zag deze functie "al geschreven" en
   * sloeg het wissen over — een onverdiend cadeau op de order. Voeg er dus geen tweede
   * schrijfpad bij; laat elke aanleiding hier binnenkomen. */
  let cadeauStand = null;
  let cadeauBezig = false;
  let cadeauWachtend = null;

  /* Eén verzoek tegelijk, en hoogstens één wachtende — de nieuwste. Niet een ketting
   * die alles achter elkaar afwerkt: elke POST draagt de vólledige stand, dus een
   * tussenliggende is per definitie achterhaald, en een rij van drie zou de laatste
   * (meestal de opruimstand) drie retourtijden laten wachten. Zo is de vertraging
   * hoogstens één retour, ongeacht hoe snel er geklikt wordt.
   *
   * `keepalive` laat een lopend verzoek de paginanavigatie overleven — nodig omdat
   * `/cart` de cadeautredes helemaal niet rendert en er daar dus geen `cd-form`-vangnet
   * is; wie vanaf de la doorklikt naar /cart en afrekent, leunt volledig op deze POST.
   *
   * ⚠ Eén geval blijft onbepaald: navigeren terwijl er een oudere POST loopt én er een
   * nieuwere stand klaarstaat. `pagehide` stuurt die nieuwere dan alsnog, maar welke van
   * de twee als laatste bij Shopify landt is niet te sturen. Dat is niet erg meer sinds
   * `sections/cart.liquid` een cadeau dat de drempel niet haalt zelf uit het
   * afrekenformulier wist — de weg naar de checkout repareert zichzelf dus. Wat er
   * overblijft zijn de versnelde betaalknoppen, die het formulier overslaan — en díé
   * zijn sinds 25-08-2026 gedekt door `cadeauRegelsSyncen()` hieronder: het cadeau is
   * dan een echte wagenregel, en een wagenregel slaat geen betaalknop over.
   * Zie de notitie bovenaan `snippets/sm-cadeau-tredes.liquid`. */
  /* Ook deze schrijfronde is een belofte, en om dezelfde reden als
   * `regelsLopend`: het cart attribute is de leesbare vorm op de order waar
   * fulfilment op werkt. De hidden inputs in het cart-formulier op de
   * wagenpagina waren het vangnet, maar die post niemand meer — de afrekenknop
   * doet `preventDefault()` en navigeert zelf. Bleef dit vuur-en-vergeet, dan
   * kon een oude "Cadeau vanaf €75" alsnog op de order landen.
   *
   * ⚠ Schrijf hierboven geen letterlijke Liquid-tag: dit blok staat in het
   * Liquid-bestand, dus een `{`+`% form %`+`}` in een JS-commentaar wordt gewoon
   * geparseerd en levert "LiquidTag 'form' was closed". */
  let cadeauLopend = null;

  function cadeauVersturen() {
    if (cadeauBezig) return cadeauLopend || Promise.resolve();
    if (!cadeauWachtend) return Promise.resolve();
    cadeauBezig = true;
    cadeauLopend = (async () => {
      try {
        // Een lus en géén staartaanroep. `.then(() => cadeauVersturen())` gaf een
        // "chaining cycle": als er niets meer wachtte gaf die aanroep `cadeauLopend`
        // terug — de belofte die op dat moment zélf werd opgelost. De lus haalt
        // ingehaalde standen net zo goed op en kan zichzelf niet oplossen.
        while (cadeauWachtend) {
          const attributes = cadeauWachtend;
          cadeauWachtend = null;
          try {
            const r = await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes }),
              keepalive: true,
            });
            // Een 429 of 422 is een geslaagde fetch en zou anders stil verdwijnen. Voor
            // afrekenen vanaf /cart of met een betaalknop bestaat geen vangnet — `cd-form`
            // dekt alleen de drawer — dus de stand moet opnieuw geprobeerd kunnen worden.
            if (!r.ok) cadeauStand = null;
          } catch {
            cadeauStand = null;
          }
        }
      } finally {
        cadeauBezig = false;
      }
    })();
    return cadeauLopend;
  }

  // Verlaat de klant de pagina met een stand die nog niet weg is, dan gaat hij hier
  // alsnog mee — óók als er nog een oudere POST loopt. Die twee kunnen dan in
  // willekeurige volgorde landen, en dat is bewust de minst slechte keuze: hem
  // wéglaten betekent gegarandeerd de oude stand, hem sturen betekent een kans op de
  // juiste. En sinds `sections/cart.liquid` een niet-verdiend cadeau zelf uit het
  // afrekenformulier wist, repareert de weg naar de checkout zich daarna alsnog.
  // `pagehide` en niet `beforeunload`: dat laatste vuurt niet op mobiel Safari.
  window.addEventListener('pagehide', () => {
    cadeauBezig = false;
    cadeauVersturen();
  });

  function cadeausSchrijven() {
    // Alles met een stempel telt mee: de verborgen velden van een trede met één cadeau,
    // de lege opruimvelden van een trede die níét gehaald wordt, én de aangevinkte radio
    // van een trede met twee. Dat maakt dit de vólledige stand in plaats van alleen wat
    // gehaald is — anders schrijft hij wel en wist hij nooit.
    //
    // Een niet-aangevinkte radio overslaan en niet als lege waarde meesturen: allebei de
    // radio's van één trede dragen dezelfde sleutel, dus wie ze alle twee wegschrijft
    // laat de laatste de keuze van de klant overschrijven.
    const attributes = {};
    document.querySelectorAll('[data-cadeau]').forEach((v) => {
      if (v.type === 'radio' && !v.checked) return;
      attributes[v.dataset.cadeau] = v.value;
    });

    // Niet posten als er niets te melden valt, en niet opnieuw posten als de stand
    // ongewijzigd is. Zonder deze twee ging er bij élke verversing een tweede
    // cart-request mee, terwijl de omliggende code mutaties juist serialiseert.
    const stand = JSON.stringify(attributes);
    if (stand !== '{}' && stand !== cadeauStand) {
      cadeauStand = stand;

      // Nieuwste stand wint. Stond er al een te wachten, dan was die achterhaald —
      // hij wordt hier overschreven en niet in een rij gezet.
      cadeauWachtend = attributes;
      cadeauVersturen();
    }

    // Buiten de ongewijzigd-toets: het attribuut kan al kloppen terwijl de regel
    // ontbreekt — bij een verse paginalading is `cadeauStand` leeg maar staat de
    // wagen er al, en na een mislukte toevoeging verandert de stand niet.
    cadeauRegelsSyncen();
  }

  /* Het cadeau als échte wagenregel van € 0.
   *
   * De Shopify Function achter "Tiered Gifts - 100% Korting" prijst elke regel met
   * property `_tiered_gift: "true"` voor 100% af. Hij telt zelf niets: geen drempel,
   * geen productlijst. Wie een cadeau verdient wordt hier bepaald — dezelfde stempels
   * die het cart attribute schrijven, dus de twee kunnen niet uiteenlopen.
   *
   * Tredes stapelen vanzelf: bij 21 maaltijden staan de tredes 12, 18 én 21 aan en
   * levert dit drie regels op. Dat is precies de 12+1 / 18+2 / 21+3 uit de campagne,
   * zonder dat er ergens een aantal geconfigureerd hoeft te worden.
   *
   * ⚠ De poort staat alléén hier. De Function prijst élke regel met dat stempel af,
   * ook een pakket van € 221,30 dat iemand er met een eigen `/cart/add.js` in zet.
   * Dat gat bestaat sinds 22-02-2026 en is bewust geaccepteerd (25-08-2026); het
   * dichten vraagt een nieuwe deploy van de function met de drempel in zijn eigen
   * configuratie-metafield. Zie `sportmeals/marketing/septembercampagne-2026/OPENSTAAND.md`.
   */
  /* De keuze van de klant is de waarheid tot de server hem bevestigt.
   *
   * Zonder deze twee kaarten verloor snel wisselen: `verversen` vervangt de
   * binnenkant van de la met de sectie zoals de sérver hem kent, en die kende de
   * verse klik nog niet — de radio sprong terug en een openstaande trede klapte
   * dicht. De volgende sync las dan die teruggesprongen stand als "gewenst" en
   * zette het oude cadeau terug. Vandaar: laatste klik wint, ook over een
   * verversing heen. Ze leven alleen zolang de pagina leeft; een echte herlading
   * haalt de stand uit de wagen zelf. */
  const keuzeLokaal = new Map();
  const tredesOpen = new Set();

  function cadeauStandHerstellen() {
    keuzeLokaal.forEach((waarde, trede) => {
      const radios = [...document.querySelectorAll('input[type="radio"][data-cadeau]')].filter(
        (r) => r.dataset.cadeau === trede,
      );
      // ⚠ Alleen herstellen als de onthouden waarde nog bestáát. De waarde is
      // `titel (sku)` en de sku komt uit de eerst-leverbare variant; raakt die
      // smaak uitverkocht, dan drijft de waarde af en zette de oude versie élke
      // radio van de trede uit. Daarna vond `cadeauRegelsSyncen` niets in
      // `gewenst`, haalde het cadeau uit de wagen en schreef een leeg attribuut —
      // een verdiend cadeau dat stil verdween. Geen match = de serverstand
      // (`checked` uit Liquid) blijft staan.
      if (!radios.some((r) => r.value === waarde)) return;
      radios.forEach((r) => {
        r.checked = r.value === waarde;
      });
    });
    document.querySelectorAll('details.cd-cadeau-trede').forEach((d) => {
      const sleutel = d.querySelector('[data-cadeau]')?.dataset.cadeau;
      if (sleutel && tredesOpen.has(sleutel)) d.open = true;
    });
  }

  let regelsBezig = false;
  let regelsOpnieuw = false;
  /* De lópende ronde als belofte.
   *
   * ⚠ Zonder deze verwijzing kon een aanroeper níét echt wachten, en dat kostte
   * geld. `verversen()` roept `cadeausSchrijven()` aan en die roept
   * `cadeauRegelsSyncen()` aan; die zet `regelsBezig` al vóór zijn eerste
   * `await`. Een `await cadeauRegelsSyncen()` dáárna — precies wat
   * `smWagenHersynchroniseren` doet voor de afrekenknop op /cart — viel dus door
   * de her-intreepoort en loste meteen op. Gevolg: wie van 18 naar 17 ging en
   * Afrekenen klikte, werd doorgestuurd terwijl de `/cart/change.js` die het
   * niet-verdiende cadeau weghaalt nog onderweg was — en het cadeau ging gratis
   * mee. Gevonden in de review van 25-08-2026.
   *
   * De belofte dekt óók de ingehaalde ronde: anders wacht de knop wel op de
   * eerste ronde maar niet op de correctie die daarna kwam. */
  let regelsLopend = null;

  function cadeauRegelsSyncen() {
    // Niet wéggooien maar onthouden: wie twee keer snel wisselt verwacht dat de
    // tweede klik telt, niet dat hij verdampt omdat de eerste nog liep.
    if (regelsBezig) {
      regelsOpnieuw = true;
      return regelsLopend || Promise.resolve();
    }
    regelsBezig = true;
    regelsLopend = (async () => {
      try {
        // Lus en geen recursie, om dezelfde reden als bij `cadeauVersturen`: een
        // staartaanroep zou de belofte met zichzelf kunnen oplossen. Een ronde die
        // tijdens deze ronde werd aangevraagd hoort bíj deze belofte — anders wacht
        // de afrekenknop wel op de eerste ronde maar niet op de correctie erna.
        // ⚠ Met een dak erop. Deze lus staat sinds de afrekenknop hem afwacht op
        // een blokkerend pad: de knop staat disabled tot hij klaar is. Convergeert
        // hij niet — Shopify's aantal-regels duwen de cadeauregel boven 1, of een
        // andere app zet hem terug na de change.js — dan draait hij eeuwig, gooit
        // niets (dus de catch daar vuurt niet) en is de knop permanent dood.
        // Drie rondes is ruim: ronde 1 zet de wagen goed, ronde 2 is de
        // her-intredende vraag van `verversen`, ronde 3 is marge.
        let ronden = 0;
        do {
          regelsOpnieuw = false;
          await regelsRonde();
          ronden += 1;
        } while (regelsOpnieuw && ronden < 3);
      } finally {
        regelsBezig = false;
        regelsOpnieuw = false;
      }
    })();
    return regelsLopend;
  }

  async function regelsRonde() {
    // Gewenste stand: per gehaalde trede één variant. Een trede die niet gehaald
    // wordt rendert een lege waarde en valt hier dus vanzelf af.
    const gewenst = new Map();
    document.querySelectorAll('[data-cadeau-variant]').forEach((v) => {
      if (v.type === 'radio' && !v.checked) return;
      if (!v.value || !v.dataset.cadeauVariant) return;
      gewenst.set(v.dataset.cadeau, v.dataset.cadeauVariant);
    });

    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
    if (!cart) return;

    // Opruimen vóór toevoegen, en niet andersom: wie van cadeau wisselt zou anders
    // even twee gratis regels in de wagen zien staan.
    const gezien = new Set();
    const weg = [];
    for (const item of cart.items) {
      if (!item.properties || item.properties._tiered_gift !== 'true') continue;
      const trede = item.properties._tiered_gift_trede || '';
      const klopt =
        !gezien.has(trede) &&
        item.quantity === 1 &&
        gewenst.get(trede) === String(item.variant_id);
      if (klopt) gezien.add(trede);
      else weg.push(item.key);
    }

    let veranderd = false;
    for (const key of weg) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      }).catch(() => null);
      if (r && r.ok) veranderd = true;
    }

    for (const [trede, variant] of gewenst) {
      if (gezien.has(trede)) continue;
      // Mislukt dit — uitverkocht, of een variant die niet meer bestaat — dan blijft
      // het cart attribute staan en ziet fulfilment de keuze alsnog. Liever een
      // cadeau dat met de hand meegaat dan een afrekening die klapt.
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(variant),
              quantity: 1,
              properties: { _tiered_gift: 'true', _tiered_gift_trede: trede },
            },
          ],
        }),
      }).catch(() => null);
      if (r && r.ok) veranderd = true;
    }

    if (!veranderd) return;

    // Verversen zodat de gratis regel meteen in de wagen staat. `verversen` roept
    // `cadeausSchrijven` weer aan; `regelsBezig` staat nog aan, dus die vraag
    // wordt als `regelsOpnieuw` ingehaald ná deze ronde en wél afgewacht. Geen
    // lus: die tweede ronde vindt de wagen op orde, zet `veranderd` niet en
    // ververst dus niet opnieuw.
    const html = await fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .catch(() => null);
    if (html) verversen(html);
  }

  function verversen(html) {
    if (!html) return false;
    // Wie midden in het intikken van een aantal staat, mag zijn veld niet kwijt
    // raken aan een verversing die door een ándere regel is uitgelokt.
    const actief = document.activeElement;
    const focusStepper = actief && actief.closest ? actief.closest('[data-stepper]') : null;
    const focusKey = focusStepper ? focusStepper.dataset.key : null;
    const focusRol =
      actief && actief.matches
        ? actief.matches('[data-step-value]')
          ? 'veld'
          : actief.matches('[data-step]')
            ? actief.dataset.step
            : null
        : null;
    const focusInDrawer = Boolean(actief && actief.closest && actief.closest('[data-cart-inner]'));
    const vers = new DOMParser().parseFromString(html, 'text/html');
    const huidig = document.querySelector('[data-cart-inner]');
    const nieuw = vers.querySelector('[data-cart-inner]');
    if (!nieuw || !huidig) return false;

    huidig.innerHTML = nieuw.innerHTML;
    // Vóór `cadeausSchrijven`, want die leest de radio's om te bepalen wat er in
    // de wagen hoort. Leest hij de teruggesprongen serverstand, dan draait hij de
    // verse keuze van de klant terug.
    cadeauStandHerstellen();
    qtyHerstellen();
    // ⚠ De verse sectie brengt een afrekenknop mee die de sérverstand kent. Staat
    // er nog een aantal in de rust te wachten, dan toont het veld al het nieuwe
    // getal terwijl die knop van het oude uitgaat — en dan rekent iemand af met
    // een wagen die niet is wat hij ziet. Op slot tot de laatste schrijfronde
    // geland is. Gevonden in de tweede Codex-review van 25-08-2026.
    if (qtyLokaal.size > 0) {
      const knopNa = document.querySelector('[data-cart-inner] [name="checkout"]');
      if (knopNa) knopNa.disabled = true;
    }
    if (focusKey && focusRol) focusTerug(actief, focusInDrawer, focusKey, focusRol);
    cadeausSchrijven();

    const versRoot = vers.querySelector('[data-cart-root]');

    // ⚠ Het wagentotaal moet hier mee overgeschreven worden. `[data-cart-root]`
    // is de búitenste laag en die wordt niet vervangen — alleen zijn `innerHTML`
    // — dus elk attribuut dat híér staat blijft hangen op de waarde van de
    // laatste volledige paginalading. Zonder deze regel toont de toevoegmelding
    // na een toevoeging het oude bedrag naast het nieuwe aantal: op een pagina
    // die met een lege wagen laadde las dat "1 artikel · totaal €0,00".
    const versTotaal = versRoot?.dataset.cartTotaal;
    if (versTotaal !== undefined) root().dataset.cartTotaal = versTotaal;

    const aantal = versRoot?.dataset.cartCount;
    if (aantal !== undefined) {
      root().dataset.cartCount = aantal;
      document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
        badge.textContent = aantal;
        badge.hidden = aantal === '0';
      });
      // De toegankelijke naam van de wagenknop hangt niet aan het telletje maar
      // aan het label van de link; zonder deze regel meldt een schermlezer nog
      // het aantal van de laatste volledige paginalading. Het label komt uit
      // Liquid, want daar staat het enkelvoud/meervoud al goed.
      const linklabel = versRoot?.dataset.cartLinklabel;
      if (linklabel) {
        document.querySelectorAll('[data-cart-link]').forEach((link) => {
          link.setAttribute('aria-label', linklabel);
        });
      }
    }

    // Beide meldingen krijgen dezelfde tekst: één staat in het dialog en werkt
    // als hij open is, de ander erbuiten en werkt als hij dicht is.
    const tekst = versRoot?.dataset.cartMeldingTekst;
    if (tekst) {
      document.querySelectorAll('[data-cart-melding]').forEach((el) => {
        el.textContent = tekst;
      });
    }
    return true;
  }

  // Kaart-ATC wisselt naar de stepper zodra het product in de wagen ligt, en
  // terug zodra het eruit is. Beide standen staan al in de HTML; hier wordt
  // alleen omgeschakeld, zodat er geen markup in JS zit.
  function kaartStand(wrap, regel) {
    const stepper = wrap.querySelector('[data-stepper]');
    if (!stepper) return;
    if (regel && regel.quantity > 0) {
      stepper.dataset.key = regel.key;
      const veldK = stepper.querySelector('[data-step-value]');
        if (veldK.tagName === 'INPUT') veldK.value = regel.quantity;
        else veldK.textContent = regel.quantity;
    }
    wrap.toggleAttribute('data-in-cart', Boolean(regel && regel.quantity > 0));
  }

  function kaartenSync(cart) {
    if (!cart || !cart.items) return;
    document.querySelectorAll('[data-card-atc]').forEach((wrap) => {
      // ⚠ Cadeauregels overslaan. Ze matchen op `variant_id` net zo goed als een
      // betaalde regel, dus zonder deze toets sloeg de kaart van een cadeaumaaltijd
      // om naar de stepper-stand en wees de min-knop naar de gratis regel — de klant
      // kon dat product dan niet meer gewoon kopen. Gevonden in de Codex-review van
      // 25-08-2026.
      const regel = cart.items.find(
        (i) => String(i.variant_id) === wrap.dataset.variant && !(i.properties && i.properties._tiered_gift === 'true'),
      );
      kaartStand(wrap, regel);
    });
    kaartenGewijzigd();
  }

  // Aankondiging, geen tweede schrijver. Wie meeluistert leest de stand uit de
  // kaarten die hierboven al bijgewerkt zijn — hij haalt de wagen niet zelf op
  // en post niets. Zonder dit bleef de rijteller in stap 4 van de pakket-PDP op
  // de serverstand staan: die sectie wordt bij een AJAX-mutatie niet ververst.
  const kaartenGewijzigd = () => document.dispatchEvent(new CustomEvent('sm:kaarten'));

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.action || !form.action.includes('/cart/add')) return;

    // Poort, dubbel gegrendeld. Een try-out-pakket stuurt zeven
    // `properties[Meal N]` mee; die ordervorm is in stap 3 geverifieerd en blijft
    // lopen zoals hij loopt — gewone submit, volledige paginalading.
    //
    // `data-keuzepakket` komt uit `sm-keuze-instructie` en staat er vanaf de
    // server-render. De `properties[...]`-controle erna is de vangnetlaag voor
    // elk ander formulier waar een app velden in zet. Alleen die tweede zou een
    // gat laten: die velden komen van de app-embed, dus een klik vóór de
    // injectie glipt erlangs en legt een pakket zonder maaltijdkeuze in de wagen.
    if (form.querySelector('[data-keuzepakket]')) return;
    if (form.querySelector('[name^="properties["]')) return;

    // Altijd onderscheppen, ook als er al een verzoek loopt. Hier stond een
    // `if (bezig) return` vóór deze regel, met als afweging dat een volledige
    // paginalading beter is dan een klik die stil verdwijnt. Die afweging klopte,
    // maar de uitkomst niet: het formulier postte dan native naar /cart/add en de
    // klant belandde op de winkelwagenpagina. Wachten is de derde optie die er
    // niet was.
    event.preventDefault();
    inWachtrij(() => toevoegen(form));
  });

  // Eén toevoeging, uitgevoerd vanuit de rij. Zet `bezig` niet zelf: dat doet
  // `inWachtrij`, en die weet ook wanneer de laatste taak klaar is.
  async function toevoegen(form) {
    const knop = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    data.append('sections', SECTIE);
    data.append('sections_url', window.location.pathname);
    if (knop) knop.disabled = true;

    // Vanaf het moment dat `fetch` oplost heeft de server de toevoeging gezien.
    // Alles daarná — ook het lezen van de body — mag dus nooit meer op
    // `form.submit()` uitkomen: een afgebroken body-lees op een haperende
    // verbinding zou van één klik twee stuks maken. Alleen een mislukte fetch,
    // waarbij het verzoek de server niet haalde, valt terug op de gewone route.
    let respons;
    try {
      respons = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
    } catch {
      // Een afgewezen `fetch` zegt níét of het verzoek Shopify gehaald heeft. Het
      // kan zijn dat er niets is toegevoegd, maar ook dat de toevoeging geslaagd
      // is en alleen het antwoord onderweg wegviel. Opnieuw versturen zou in dat
      // tweede geval van één klik twee stuks maken; doorsturen naar de wagen laat
      // de klant zien wat er werkelijk in zit, in beide gevallen.
      naarWagen();
      return;
    }

    // Een afgewezen toevoeging (uitverkocht, limiet) laat Shopify zelf
    // afhandelen op de gewone route — dan ziet de klant de echte melding.
    // /cart/add.js voegt bij een 422 niets toe, dus opnieuw versturen dubbelt niet.
    if (!respons.ok) {
      form.submit();
      return;
    }

    let uitkomst;
    try {
      uitkomst = await respons.json();
    } catch {
      // De toevoeging is geslaagd, alleen het antwoord kwam niet aan. Doorsturen
      // naar de wagen laat de klant zien wat er werkelijk in zit.
      naarWagen();
      return;
    }

    if (knop) knop.disabled = false;
    // Toevoegen opent de drawer niet meer. Er stond hier `openen()` vóór
    // `verversen()`, met als reden dat er twee `[data-cart-melding]`-regio's zijn
    // — één in het dialog, één erbuiten — en dat een wissel van inertheid ná het
    // schrijven een schermlezer beide kon laten horen. Die redenering vervalt met
    // de drawer dicht: het dialog blijft `display: none`, dus alleen de regio
    // erbuiten staat in de toegankelijkheidsboom en spreekt één keer.
    if (!verversen(uitkomst.sections && uitkomst.sections[SECTIE])) {
      naarWagen();
      return;
    }
    const regel = uitkomst.items ? uitkomst.items[0] : uitkomst;
    // Staat de drawer al open — toevoegen kan ook vanuit de cross-sell erín — dan
    // ligt het paneel achter een modale backdrop en is het `inert`. De drawer laat
    // de nieuwe stand dan zelf al zien.
    if (!drawer()?.open) toastTonen(regel);
    // Niet alleen het formulier dat verstuurde: élke plek die deze variant toont.
    // Stap 4 van de pakket-PDP en de aanbevelingsrij in de la kunnen hetzelfde
    // gerecht tonen, en `sm-pakket` wordt na een AJAX-toevoeging niet opnieuw
    // gerenderd — alleen de drawer-sectie. Zonder deze regel bleef daar "Voeg
    // toe" staan terwijl het gerecht al in de wagen lag.
    document
      .querySelectorAll('[data-card-atc][data-variant="' + regel.variant_id + '"]')
      .forEach((wrap) => kaartStand(wrap, regel));
    kaartenGewijzigd();
  }

  const naarWagen = () => {
    const wortel = window.Shopify?.routes?.root || '/';
    window.location.assign(wortel + 'cart');
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    // Een modifier-klik hoort een nieuw tabblad te openen. De knop is met opzet
    // een échte link naar /cart gebleven; dat onderscheppen haalt precies de
    // enige reden weg waarom dat de moeite waard was.
    if (open && drawer() && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      openen();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      drawer()?.close();
      return;
    }

    const stap = event.target.closest('[data-step]');
    if (stap) {
      const stepper = stap.closest('[data-stepper]');
      const key = stepper.dataset.key;
      const nieuw = qtyHuidig(stepper) + Number(stap.dataset.step);
      if (nieuw < 0) return;
      qtyPlannen(key, nieuw);
      return;
    }

    const weg = event.target.closest('[data-regel-weg]');
    if (weg) {
      // Verwijderen wacht niet op de rustpauze: dit is een besluit, geen aanloop.
      qtyPlannen(weg.dataset.regelWeg, 0, true);
    }
  });

  /* ── Aantallen ─────────────────────────────────────────────────────────────
   * Lokaal en meteen; één schrijfronde per rustpauze.
   *
   * Tot 25-08-2026 deed élke klik een eigen `/cart/change.js` mét sectie-render en
   * zette hij intussen álle steppers op slot — plus `if (bezig) return`, dus een
   * klik tijdens dat wachten verdween gewoon. Wie 35 stuks wilde moest 34 keer
   * klikken én 34 keer wachten, en doortikken werkte actief tegen hem.
   *
   * Nu staat het getal meteen goed en gaat er na 450 ms rust één verzoek met het
   * eindaantal. De schrijfacties lopen nog steeds door `inWachtrij`, dus ze landen
   * op volgorde; wat eruit ging is de wachttijd vóór elke klik, niet de
   * serialisatie erachter.
   *
   * De afrekenknop blijft wél op slot zolang er een aantal openstaat. Dat is het
   * punt waar dit over geld gaat: staat de wagen op precies zeven maaltijden en
   * drukt iemand op min en meteen daarna op afrekenen, dan rekent hij anders af
   * met een aantal dat nog onderweg is.
   */
  const qtyLokaal = new Map();
  const qtyTimers = new Map();

  function qtyLees(el) {
    if (!el) return 0;
    const ruw = 'value' in el && el.tagName === 'INPUT' ? el.value : el.textContent;
    return Number(String(ruw).replace(/[^0-9]/g, '')) || 0;
  }
  function qtyHuidig(stepper) {
    const key = stepper.dataset.key;
    if (qtyLokaal.has(key)) return qtyLokaal.get(key);
    return qtyLees(stepper.querySelector('[data-step-value]'));
  }
  function qtyToon(key, aantal) {
    document.querySelectorAll(`[data-stepper][data-key="${key}"] [data-step-value]`).forEach((v) => {
      if (v.tagName === 'INPUT') v.value = aantal;
      else v.textContent = aantal;
    });
  }
  // Na een sectieverversing: dezelfde reden als bij de cadeaukeuze. De verse
  // sectie draagt de stand zoals de sérver hem kent, en die kent een aantal dat
  // nog in de rust wacht nog niet.
  function qtyHerstellen() {
    qtyLokaal.forEach((aantal, key) => qtyToon(key, aantal));
  }

  function qtyPlannen(key, aantal, direct) {
    qtyLokaal.set(key, aantal);
    qtyToon(key, aantal);
    const knop = document.querySelector('[data-cart-inner] [name="checkout"]');
    if (knop) knop.disabled = true;
    clearTimeout(qtyTimers.get(key));
    if (direct) {
      qtyTimers.delete(key);
      qtySchrijven(key);
    } else {
      qtyTimers.set(key, setTimeout(() => qtySchrijven(key), 450));
    }
  }

  function qtySchrijven(key) {
    qtyTimers.delete(key);
    inWachtrij(async () => {
      const aantal = qtyLokaal.get(key);
      if (aantal === undefined) return;
      try {
        const respons = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: aantal,
            sections: SECTIE,
            sections_url: window.location.pathname,
          }),
        });
        const cart = await respons.json();
        if (!respons.ok) {
          naarWagen();
          return;
        }
        // Alleen opruimen als er intussen niet alweer geklikt is: staat er een
        // nieuwer aantal, dan moet dát blijven staan tot zijn eigen ronde landt.
        if (qtyLokaal.get(key) === aantal) qtyLokaal.delete(key);
        if (!verversen(cart.sections && cart.sections[SECTIE])) {
          naarWagen();
          return;
        }
        kaartenSync(cart);
      } catch {
        // Zonder deze vangst zou een afgebroken verbinding een stille no-op zijn:
        // het aantal verandert niet en de klant hoort niet waarom.
        naarWagen();
      }
    });
  }

  /* De wagenpagina heeft geen eigen cadeaulogica: de tredes staan in de la, en die
   * is op elke pagina aanwezig. Dit is de enige naar buiten toe zichtbare haak, en
   * hij bestaat voor één doel — de afrekenknop op `/cart` moet de cadeauregels
   * kunnen laten kloppen vóór hij doorstuurt. Eerst de sectie verversen (de la
   * toont daar de stand van vóór de wijziging), dan pas synchroniseren. */
  /* ⚠ De afrekenknop ín de la had dezelfde fout als die op /cart, en die is hier
   * pas de dérde deur naar dezelfde gratis maaltijd. `cd-form` is een gewoon
   * cart-formulier: hij post en navigeert zélf. Wie
   * een cadeau wisselt of onder een trede zakt en meteen afrekent, vertrekt dus
   * terwijl de `/cart/add.js` en `/cart/change.js` van `cadeauRegelsSyncen()` nog
   * onderweg zijn — met een cadeauregel die niet meer klopt.
   *
   * ⚠ En schrijf hier geen Liquid-tag uit, ook niet als voorbeeld: theme check
   * weigert elke Liquid-tag in een javascript-blok, óók in commentaar.
   *
   * Zelfde vorm als op de wagenpagina: onderscheppen, wachten tot beide
   * schrijfrondes landen, dan pas doorsturen. `cdAfrekenen` is de eenmaligheid —
   * zonder die vlag zou een tweede Enter tijdens het wachten een tweede ronde
   * starten. Gevonden in de derde Codex-review van 25-08-2026. */
  let cdAfrekenen = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form || form.id !== 'cd-form') return;
    if (cdAfrekenen) return;
    event.preventDefault();
    cdAfrekenen = true;
    const knop = form.querySelector('[name="checkout"]');
    if (knop) knop.disabled = true;
    try {
      // Aanhaken op een lopende ronde in plaats van er een af te dwingen — zie de
      // noot bij `smWagenHersynchroniseren`.
      await (regelsBezig ? regelsLopend : cadeauRegelsSyncen());
      await cadeauVersturen();
    } catch {
      // ⚠ Fail-closed, net als op /cart. Hier stond "doorsturen is beter dan
      // vastlopen"; op een pad dat een gratis product kan weggeven klopt dat niet.
      // De la opnieuw laten laden toont de klant wát de server werkelijk heeft.
      cdAfrekenen = false;
      if (knop) knop.disabled = false;
      window.location.assign(window.location.pathname);
      return;
    }
    window.location.href = '/checkout';
  });

  window.smWagenHersynchroniseren = async function () {
    const html = await fetch(`${window.location.pathname}?section_id=${SECTIE}`)
      .then((r) => (r.ok ? r.text() : null))
      .catch(() => null);
    // ⚠ Fail-closed. Lukt de sectie-render niet, dan draagt de la nog de stand van
    // vóór de wijziging — en `cadeauRegelsSyncen()` leest juist die DOM om te
    // bepalen wat er in de wagen hóórt. Zonder deze worp zou hij bij 18 → 17 de
    // trede-18-radio nog aangevinkt zien en het cadeau dus laten staan: precies
    // het gat dat deze haak moest dichten, nu via een mislukte render. De
    // aanroepers vangen de fout en herladen. Gevonden in de vijfde Codex-review
    // van 25-08-2026.
    if (!html || !verversen(html)) {
      throw new Error('sectie-render mislukt; niet synchroniseren tegen een verouderde la');
    }
    // ⚠ Aanhaken, niet opnieuw vragen. `verversen()` heeft via `cadeausSchrijven`
    // al een ronde gestart; een gewone `cadeauRegelsSyncen()` zou hier de
    // her-intreepoort raken en `regelsOpnieuw` zetten — dus altijd een extra
    // /cart.js-ronde afdwingen op precies het pad waar de klant naar een
    // uitgeschakelde knop kijkt. Loopt er niets, dan start deze aanroep er wél
    // een; dat is de stand als de wagen niets te corrigeren had.
    await (regelsBezig ? regelsLopend : cadeauRegelsSyncen());
    // Beide: de regels (wat de klant betaalt) én het attribuut (wat fulfilment
    // leest). Alleen op de regels wachten liet een verlopen "Cadeau vanaf €75"
    // op de order staan.
    await cadeauVersturen();
  };

  // Zelf een aantal intikken. `change` en niet `input`: bij elke aanslag plannen
  // zou "35" onderweg als 3 wegschrijven. Enter bevestigt via blur.
  document.addEventListener('change', (event) => {
    const veld = event.target.closest('[data-step-value]');
    if (!veld || veld.tagName !== 'INPUT') return;
    const stepper = veld.closest('[data-stepper]');
    if (!stepper) return;
    const n = Math.max(0, Math.min(999, qtyLees(veld)));
    qtyPlannen(stepper.dataset.key, n);
  });
  document.addEventListener('keydown', (event) => {
    const veld = event.target.closest('[data-step-value]');
    if (!veld || veld.tagName !== 'INPUT' || event.key !== 'Enter') return;
    event.preventDefault();
    veld.blur();
  });

  // Een cadeaukeuze is een aanleiding om te schrijven, geen eigen schrijver. Zie de
  // waarschuwing bij `cadeausSchrijven`: hier stond een tweede `fetch` die alleen dít
  // ene attribuut postte, buiten `cadeauStand` om. Daarna wist de cache niet meer wat
  // de wagen wist, en de opruimronde sloeg over — cadeau op de order zonder drempel.
  //
  // De sectie wordt met opzet niet ververst: de radio staat al aan, en een
  // innerHTML-vervanging zou de focus weghalen bij iemand die net met de
  // pijltjestoetsen door de keuzes liep. `bezig` blijft er ook buiten — dit verzoek
  // raakt geen enkel aantal, en een cadeaukeuze mag een lopende stapklik niet
  // blokkeren.
  document.addEventListener('change', (event) => {
    const veld = event.target.closest('[data-cadeau]');
    if (!veld) return;
    if (veld.type === 'radio' && veld.checked) keuzeLokaal.set(veld.dataset.cadeau, veld.value);
    cadeausSchrijven();
  });

  // Open of dicht is een voorkeur van de klant, geen serverstand: een verversing
  // na een aantalswijziging mag een opengeklapte trede niet dichtslaan.
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (!(d instanceof HTMLDetailsElement) || !d.classList.contains('cd-cadeau-trede')) return;
    const sleutel = d.querySelector('[data-cadeau]')?.dataset.cadeau;
    if (!sleutel) return;
    if (d.open) tredesOpen.add(sleutel);
    else tredesOpen.delete(sleutel);
  }, true);

  // Klik op de backdrop sluit het paneel: buiten het dialog-vlak geklikt.
  document.addEventListener('click', (event) => {
    const d = drawer();
    if (d && d.open && event.target === d) d.close();
  });

  // Ook bij het laden: de drawer staat op elke pagina en kan al een gehaalde trede
  // met één cadeau tonen zonder dat er iets ververst is.
  cadeausSchrijven();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-goals"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sm-reveal]').forEach((row) => {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    row.setAttribute('data-reveal-armed', '');
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        row.classList.add('inview');
        observer.disconnect();
      },
      { threshold: 0.25 }
    );
    observer.observe(row);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header"]) return;
  try {
    
  document.querySelectorAll('[data-sm-nav]').forEach((sheet) => {
    const root = sheet.closest('.sm-header-root');
    root?.querySelector('[data-sm-nav-open]')?.addEventListener('click', () => sheet.showModal());
    sheet.querySelector('[data-sm-nav-close]')?.addEventListener('click', () => sheet.close());
    // Klik op de backdrop sluit het paneel: buiten het dialog-vlak geklikt.
    sheet.addEventListener('click', (event) => {
      if (event.target === sheet) sheet.close();
    });
  });

  document.querySelectorAll('[data-sm-zoek]').forEach((sheet) => {
    const root = sheet.closest('.sm-header-root');
    const veld = sheet.querySelector('input[name="q"]');
    const bak = sheet.querySelector('[data-sm-zoek-resultaat]');
    if (!veld || !bak) return;

    veld.setAttribute('role', 'combobox');
    veld.setAttribute('aria-expanded', 'false');
    veld.setAttribute('aria-autocomplete', 'list');

    root?.querySelector('[data-sm-zoek-open]')?.addEventListener('click', (event) => {
      event.preventDefault();
      sheet.showModal();
      veld.focus();
    });
    sheet.querySelector('[data-sm-zoek-close]')?.addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', (event) => {
      if (event.target === sheet) sheet.close();
    });

    let actief = -1;
    const opties = () => [...bak.querySelectorAll('[role="option"]')];

    const markeer = (i) => {
      const lijst = opties();
      if (!lijst.length) return;
      // Rondlopen: vanaf de laatste omlaag komt de eerste, en andersom.
      actief = (i + lijst.length) % lijst.length;
      lijst.forEach((optie, n) => optie.setAttribute('aria-selected', n === actief ? 'true' : 'false'));
      const gekozen = lijst[actief];
      veld.setAttribute('aria-activedescendant', gekozen.id);
      gekozen.scrollIntoView({ block: 'nearest' });
    };

    const leeg = () => {
      bak.innerHTML = '';
      actief = -1;
      veld.setAttribute('aria-expanded', 'false');
      veld.removeAttribute('aria-activedescendant');
      veld.removeAttribute('aria-controls');
    };

    // Elke aanslag annuleert de vorige vlucht. Zonder dat kan een traag antwoord
    // op "ki" ná het snelle antwoord op "kip" binnenkomen en het overschrijven.
    let vlucht;
    let wachter;
    const zoek = async () => {
      const term = veld.value.trim();

      // Afbreken vóór de lengtecheck, niet erna. Wist iemand terug naar één teken
      // terwijl er nog een vlucht voor "kip" liep, dan maakte `leeg()` het paneel
      // leeg en vulde dat late antwoord het daarna alsnog — suggesties voor een
      // term die niet meer in het veld staat.
      vlucht?.abort();
      if (term.length < 2) return leeg();

      vlucht = new AbortController();
      const wortel = window.Shopify?.routes?.root || '/';
      const url = new URL(`${wortel}search/suggest`, location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('section_id', 'sm-predictive-search');
      // Tags mee laten zoeken. Standaard kijkt search/suggest alleen naar titel,
      // producttype, varianttitel en leverancier; de zoekpagina indexeert tags
      // wel. Gemeten: "kip pakket" gaf 0 in het paneel tegen 56 op de pagina.
      // De vier standaardvelden staan er expliciet bij, want fields VERVANGT de
      // standaardlijst in plaats van hem aan te vullen.
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
      try {
        const html = await fetch(url, { signal: vlucht.signal }).then((r) => (r.ok ? r.text() : ''));
        if (!html) return leeg();
        // De sectie-respons komt als volledige sectie-wrapper terug; alleen de
        // inhoud ervan hoort in het paneel.
        const gedeelte = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        bak.innerHTML = gedeelte ? gedeelte.innerHTML : html;
        // De sectie bouwt deze link uit `predictive_search.terms`, en die waarde
        // is al HTML-ontsnapt — `url_encode` codeert dan de entiteit in plaats van
        // het teken, dus "kip & beef" komt als "kip &amp; beef" op de zoekpagina
        // aan. Hier is de term nog onbewerkt, dus hier hoort de correctie.
        //
        // De verborgen velden gaan mee, en ze worden uit het formulier gelézen in
        // plaats van hier herhaald. `sm-zoekbalk` stuurt `options[prefix]=last` en
        // een `type`, en zonder die twee levert deze link een ándere uitkomst dan
        // op Enter drukken in hetzelfde veld: geen prefix-treffers op "kip", en
        // geen artikelen of pagina's. Overschrijven met een vaste lijst zou dat
        // vandaag oplossen en morgen opnieuw uiteenlopen zodra het snippet een
        // veld toevoegt — vandaar de kopie uit de DOM.
        const zoekform = veld.closest('form');
        const zoekpar = new URLSearchParams();
        zoekpar.set('q', term);
        zoekform?.querySelectorAll('input[type="hidden"][name]').forEach((h) => {
          if (h.name !== 'q' && h.value !== '') zoekpar.set(h.name, h.value);
        });
        bak.querySelector('.zoek-alles')?.setAttribute('href', `${wortel}search?${zoekpar}`);
        actief = -1;
        const lijst = bak.querySelector('[role="listbox"]');
        if (lijst) {
          lijst.id = lijst.id || 'sm-zoek-lijst';
          veld.setAttribute('aria-controls', lijst.id);
          veld.setAttribute('aria-expanded', 'true');
        } else {
          veld.setAttribute('aria-expanded', 'false');
        }
      } catch (error) {
        if (error.name !== 'AbortError') leeg();
      }
    };

    veld.addEventListener('input', () => {
      clearTimeout(wachter);
      wachter = setTimeout(zoek, 200);
    });

    veld.addEventListener('keydown', (event) => {
      const lijst = opties();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        markeer(actief + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        markeer(actief - 1);
      } else if (event.key === 'Enter' && actief >= 0 && lijst[actief]) {
        // Alleen onderscheppen als er echt iets gemarkeerd staat; anders moet
        // het formulier gewoon naar /search kunnen posten.
        event.preventDefault();
        lijst[actief].querySelector('a')?.click();
      }
    });

    // Escape sluit het dialog zelf; leegmaken zodat een volgende opening niet
    // met de suggesties van de vorige zoekopdracht opent.
    sheet.addEventListener('close', leeg);
  });

  // <details> sluit zichzelf niet bij Escape of een klik ernaast.
  const closeMegas = (event) => {
    document.querySelectorAll('[data-sm-mega][open]').forEach((mega) => {
      if (event.type === 'keydown' || !mega.contains(event.target)) mega.open = false;
    });
  };
  document.addEventListener('pointerdown', closeMegas);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegas(event);
  });

  // --ann-h houdt de sticky-offset van de sectiegroep gelijk aan de hoogte van
  // de aankondigingsbalk. Die hoogte hangt af van de vensterbreedte doordat de
  // tekst afbreekt, dus een vaste waarde loopt op een tussenformaat mis.
  (() => {
    let waarnemer = null;

    // De else-tak en de section-load-listener zijn niet optioneel. Zet de
    // merchant de aankondiging uit, dan rendert de sectie opnieuw zónder .ann
    // terwijl --ann-h op 40px blijft staan — de groep plakt dan op -40px en
    // snijdt de bovenste 40px van de blauwe balk af, de hele editor-sessie lang.
    // Andersom net zo: aankondiging aanzetten op een pagina die zonder laadde.
    const meet = () => {
      if (waarnemer) { waarnemer.disconnect(); waarnemer = null; }
      const ann = document.querySelector('.ann');
      if (!ann) {
        document.documentElement.style.setProperty('--ann-h', '0px');
        return;
      }
      const zet = () => document.documentElement.style.setProperty('--ann-h', ann.offsetHeight + 'px');
      zet();
      waarnemer = new ResizeObserver(zet);
      waarnemer.observe(ann);
    };

    meet();
    document.addEventListener('shopify:section:load', meet);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-journey"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.unbox--rail').forEach((blok) => {
    const rail = blok.querySelector('.reis-rail');
    if (!rail) return;

    blok.querySelectorAll('[data-reis-schuif]').forEach((knop) => {
      knop.addEventListener('click', () => {
        // Kaartbreedte uit de eerste kaart, zodat de sprong meebeweegt met het
        // breakpoint in plaats van een vast getal te zijn.
        const kaart = rail.querySelector('.reis-kaart');
        const stap = kaart ? kaart.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
        const zacht = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        rail.scrollBy({ left: Number(knop.dataset.reisSchuif) * stap, behavior: zacht });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pakket"] && !Shopify.designMode) return;
  try {
    
  /* Stap 1-3 zonder paginaverversing.
   *
   * Elk pakket is in Shopify een eigen product, dus de keuzeknoppen zijn links naar een
   * ander product. Dat is functioneel juist en werkt zonder JS, maar het geeft bij elke
   * klik een volledige herlading. Hieronder wordt die klik onderschept en alleen de
   * inhoud van #sm-main vervangen.
   *
   * Waarom de hele pagina ophalen en niet vijf losse section-renders: het bundeltemplate
   * telt zeven secties die allemaal van het product afhangen, en een doelpakket kan een
   * ANDER template gebruiken (de try-out-pakketten doen dat). Eén fetch houdt de pagina
   * intern consistent; vijf section-ids zouden bij een templatewissel de verkeerde
   * secties verversen.
   *
   * Waarom dit veilig is met de winkelwagen: de cart-drawer staat in layout/theme.liquid
   * BUITEN #sm-main en delegeert al zijn listeners op `document`. Een swap van #sm-main
   * laat hem dus intact, en de nieuw ingeladen "Voeg toe"-formulieren uit stap 4 worden
   * vanzelf opgepikt. Van de secties op dit template heeft alleen deze een eigen
   * javascript-blok, dus er gaat geen andere sectie-init verloren.
   */
  (() => {
    const HOOFD = '#sm-main';
    /* ⚠ Alleen links MET `data-sm-swap`. Liquid zet dat stempel uitsluitend als het
     * doelpakket hetzelfde template gebruikt als de pagina waar je staat ÉN zelf geen
     * keuzepakket is. Die tweede eis is er sinds de review van 21-08: het template
     * alléén was smaller dan de bug. Een keuzepakket hoeft geen `try-out`-suffix te
     * dragen — of Simple Bundles zijn keuzeslots injecteert hangt aan de app-configuratie,
     * niet aan het template — dus een keuzepakket op het standaardtemplate droeg dezelfde
     * suffix als een gewoon pakket en glipte langs de poort. De matrix draagt daarom een
     * achtste veld `k:` met dezelfde twee signalen die `sm-keuze-instructie` gebruikt.
     * Zonder die beperking kon een klik in stap 3 op een keuzepakket landen, en dat is geen
     * cosmetisch probleem: de zeven verplichte `properties[Meal N]`-selects worden daar
     * door de Simple Bundles-app-embed bij het laden in de DOM gezet, en een innerHTML-
     * vervanging draait die embed niet opnieuw. Je hield dan een koopknop zonder
     * maaltijdkeuze over — precies de bestelling die de poort bij de koopknop moet
     * voorkomen. Hetzelfde stempel dekt het tweede geval: sectie-CSS wordt per pagina
     * gebundeld, dus markup uit een ánder template komt binnen zonder zijn stijlen.
     * Links zonder stempel blijven gewone links en navigeren normaal. */
    const KNOPPEN = 'a.pk-seg-btn[data-sm-swap], a.pk-size-btn[data-sm-swap]';

    /* Benoemd in plaats van een IIFE: na een swap moet dit opnieuw draaien, en een
     * anonieme functie die alleen bij het laden liep zou daarna stil blijven. */
    function toonVerspring(zoek) {
      const el = document.querySelector('[data-pakket-verspring]');
      if (!el) return;
      const vanaf = new URLSearchParams(zoek ?? window.location.search).get('vanaf');
      if (!vanaf || !/^\d+$/.test(vanaf)) return;
      const maat = el.dataset.maat;
      if (vanaf === maat) return;
      el.textContent =
        el.dataset.vlees +
        ' gaat tot ' +
        el.dataset.max +
        ' maaltijden. Je koos er ' +
        vanaf +
        ', dus dit is ' +
        maat +
        '.';
      el.hidden = false;
    }

    toonVerspring();

    /* Zonder deze drie valt alles terug op gewone links. Dat is geen verlies: de
     * verversing verdwijnt, de werking niet. */
    if (!window.fetch || !window.DOMParser || !(window.history && history.pushState)) return;

    let bezig = false;
    let eigenGeschiedenis = false;
    let getoond = location.pathname + location.search;

    async function wissel(url, knop, push) {
      const hoofd = document.querySelector(HOOFD);
      if (!hoofd) {
        location.href = url;
        return;
      }
      bezig = true;
      hoofd.setAttribute('aria-busy', 'true');
      if (knop) knop.classList.add('is-laden');
      try {
        const r = await fetch(url, { credentials: 'same-origin' });
        if (!r.ok) throw new Error('status ' + r.status);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const nieuwHoofd = doc.querySelector(HOOFD);
        if (!nieuwHoofd) throw new Error('geen ' + HOOFD + ' in de respons');

        hoofd.innerHTML = nieuwHoofd.innerHTML;
        if (doc.title) document.title = doc.title;
        getoond = url;
        if (push) {
          history.pushState({ smPakket: true }, '', url);
          eigenGeschiedenis = true;
        }
        toonVerspring(new URL(url, location.origin).search);

        /* De knop waarop geklikt werd bestaat niet meer; zonder dit springt de focus
         * naar het begin van de pagina en raakt een toetsenbordgebruiker zijn plek kwijt. */
        const actief = hoofd.querySelector('[aria-current="true"]');
        if (actief && actief.focus) actief.focus({ preventScroll: true });
      } catch (e) {
        /* Nooit stil blijven staan: een mislukte swap wordt een gewone navigatie. */
        location.href = url;
      } finally {
        bezig = false;
        hoofd.removeAttribute('aria-busy');
        if (knop) knop.classList.remove('is-laden');
      }
    }

    document.addEventListener('click', (e) => {
      /* Laat de browser zijn werk doen bij middelklik, cmd/ctrl-klik en shift-klik —
       * dat zijn "open in nieuw tabblad" en "open in nieuw venster". */
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest(KNOPPEN);
      if (!a || !a.closest(HOOFD)) return;

      const doel = new URL(a.getAttribute('href'), location.href);
      if (doel.origin !== location.origin) return;

      e.preventDefault();
      if (bezig) return;
      wissel(doel.pathname + doel.search, a, true);
    });

    window.addEventListener('popstate', () => {
      /* Alleen ingrijpen op geschiedenis die wij zelf hebben geschreven. Anders zou de
       * terugknop op een pagina waar nooit geswapt is een overbodige fetch doen. */
      if (!eigenGeschiedenis) return;
      const doel = location.pathname + location.search;
      if (doel === getoond) return; // er veranderde alleen een hash
      wissel(doel, null, false);
    });
  })();

  /* Rijteller in stap 4, bijgewerkt zonder de sectie te verversen.
   *
   * De teller wordt serverzijdig gerenderd, maar `sm-pakket` wordt bij een
   * AJAX-wagenmutatie niet opnieuw opgehaald — alleen de drawer-sectie. Zonder
   * dit bleef "1x · EUR 3,95" staan nadat je een tweede ontbijtje toevoegde.
   *
   * Bewust géén eigen /cart.js-verzoek en géén tweede schrijver: de drawer heeft
   * de kaartstanden dan al bijgewerkt en meldt dat met `sm:kaarten`. Deze functie
   * leest alleen wat er in de DOM staat en telt op.
   */
  (function () {
    /* Niet Intl: die schrijft "EUR 8,40" met een spatie, terwijl Shopify's
     * money-filter er "EUR8,40" van maakt. Dat gaf twee schrijfwijzen voor
     * hetzelfde bedrag — de ene bij het laden, de andere na een klik. */
    const geld = (cent) => '\u20ac' + (cent / 100).toFixed(2).replace('.', ',');

    function tellers() {
      document.querySelectorAll('.pk-upsell-kop[data-rij]').forEach((kop) => {
        const tag = kop.dataset.rij;
        const rij = document.querySelector('.pk-upsell-rij[data-rij="' + CSS.escape(tag) + '"]');
        const stand = kop.querySelector('.pk-upsell-stand');
        if (!rij || !stand) return;

        let aantal = 0;
        let cent = 0;
        rij.querySelectorAll('[data-card-atc]').forEach((wrap) => {
          if (!wrap.hasAttribute('data-in-cart')) return;
          // `[data-step-value]` is sinds 25-08-2026 een invoerveld (zelf een aantal
          // kunnen intikken). `textContent` is daar leeg, dus dat las stil 0.
          const veldQ = wrap.querySelector('[data-step-value]');
          const q = Number(veldQ && (veldQ.tagName === 'INPUT' ? veldQ.value : veldQ.textContent)) || 0;
          aantal += q;
          cent += q * (Number(wrap.dataset.cent) || 0);
        });

        stand.textContent = aantal + '\u00d7 \u00b7 ' + geld(cent);
        stand.toggleAttribute('hidden', aantal === 0);
        const hint = document.querySelector('.pk-upsell-hint[data-rij="' + CSS.escape(tag) + '"]');
        if (hint) hint.toggleAttribute('hidden', aantal > 0);
      });
    }

    document.addEventListener('sm:kaarten', tellers);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-details"] && !Shopify.designMode) return;
  try {
    
  // De stipjes onder de ingrediëntenrail. Versiering, geen bediening: de rail
  // scrollt met muis, trackpad, sleep en toetsenbord ook zonder dit script.
  // Daarom een observer op de kaarten en geen scroll-listener met rekenwerk —
  // die moet je bij elke resize opnieuw ijken.
  //
  // Meerdere kaarten kunnen tegelijk gemarkeerd staan; er zijn er ook twee
  // tegelijk zichtbaar. Eén "actieve" stip zou moeten kiezen welke van die twee
  // de echte is, en dat is een keuze zonder antwoord.
  document.querySelectorAll('[data-ingr-rail]').forEach((rail) => {
    const dots = rail.parentElement.querySelector('[data-ingr-dots]');
    if (!dots) return;

    const kaarten = Array.from(rail.children);
    const stippen = Array.from(dots.children);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const stip = stippen[kaarten.indexOf(entry.target)];
          if (stip) stip.toggleAttribute('data-actief', entry.isIntersecting);
        });
      },
      { root: rail, threshold: 0.6 }
    );

    kaarten.forEach((kaart) => io.observe(kaart));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-pdp-hoofd"] && !Shopify.designMode) return;
  try {
    
  /* Portiewissel zonder naar de bovenkant te springen.
   *
   * De maatknoppen zijn echte links naar een ander PRODUCT — vier doelvarianten
   * zijn in deze winkel vier aparte producten. Dat blijft zo: een doel dat
   * alleen via JavaScript bereikbaar is bestaat niet voor een crawler, en die
   * vier vindbare pagina's zijn de reden dat het zo gebouwd is.
   *
   * Wat er wél weg kan is de sprong. Een gewone navigatie zet de nieuwe pagina
   * bovenaan, dus wie halverwege het koopblok van portie wisselt moet
   * terugscrollen naar precies de plek waar hij stond.
   *
   * ⚠ Bewaar de positie van het ELEMENT, niet `scrollY`. Een ruw pixelgetal
   * overzetten gaat mis omdat het een ándere pagina is: een gemeten wissel van
   * 570g naar 350g op Kip Koreaans zette 760 terug en landde op 1153, want het
   * andere product heeft een andere hoeveelheid inhoud erboven. Wat de bezoeker
   * wil is dat de maatrij blijft staan waar hij stond, en dat is een positie ten
   * opzichte van het scherm.
   *
   * sessionStorage en geen URL-parameter: de positie is van dit tabblad en van
   * deze klik, hij hoort niet in een deelbare link en niet in de geschiedenis.
   */
  (function () {
    const SLEUTEL = 'sm-maat-anker';
    const rij = () => document.querySelector('.pdp-maat');

    document.addEventListener('click', (event) => {
      const knop = event.target.closest('.pdp-maat__knop');
      if (!knop || knop.getAttribute('aria-current') === 'page') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey) return; // nieuw tabblad
      const r = rij()?.getBoundingClientRect();
      if (!r) return;
      try {
        sessionStorage.setItem(SLEUTEL, JSON.stringify({ top: r.top, op: Date.now() }));
      } catch {
        // Private mode of geblokkeerde opslag: dan springt hij zoals vroeger.
        // Een mislukte opslag mag de navigatie nooit tegenhouden.
      }
    });

    let anker = null;
    try {
      const ruw = sessionStorage.getItem(SLEUTEL);
      if (ruw) {
        sessionStorage.removeItem(SLEUTEL);
        const gelezen = JSON.parse(ruw);
        // Alleen een verse klik telt. Zonder deze grens herstelt een tab die je
        // een uur later terugpakt een positie die nergens meer op slaat.
        if (Date.now() - gelezen.op < 10000) anker = gelezen.top;
      }
    } catch {
      // Ongeldige of ontoegankelijke opslag: niets herstellen is de juiste val.
    }

    if (anker !== null) {
      const zet = () => {
        const el = rij();
        if (!el) return;
        const doel = el.getBoundingClientRect().top + window.scrollY - anker;
        // `instant`: de pagina is net geladen, een animatie vanaf de bovenkant
        // leest als een sprong met vertraging.
        window.scrollTo({ top: Math.max(0, doel), behavior: 'instant' });
      };
      zet();
      // Nog één keer ná `load`: de productfoto's erboven hebben dan hun hoogte,
      // en zonder die tweede meting schuift de rij alsnog weg. Twee keer zetten
      // is goedkoper dan wachten op elke afbeelding apart.
      window.addEventListener('load', zet, { once: true });
    }
  })();

  document.querySelectorAll('[data-pdp-track]').forEach((track) => {
    const gallery = track.closest('.pdp-gal');
    const thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-pdp-thumb]')) : [];
    const items = Array.from(track.children);
    if (thumbs.length === 0) return;

    const markeer = (index) => {
      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', String(Number(thumb.dataset.pdpThumb) === index));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.pdpThumb);
        const item = items[index];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        markeer(index);
      });
    });

    // Vegen moet de duimnagel meenemen, anders wijst hij na een swipe naar de
    // verkeerde foto. IntersectionObserver in plaats van een scroll-listener:
    // die vuurt niet bij elke pixel.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) markeer(items.indexOf(entry.target));
        });
      },
      { root: track, threshold: 0.6 }
    );
    items.forEach((item) => observer.observe(item));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-tdee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-tdee-form]');
    if (!form) return;
    event.preventDefault();

    const fout = form.querySelector('[data-tdee-fout]');
    const getal = (naam) => Number(form.elements[naam].value.trim().replace(',', '.'));
    const leeftijd = getal('leeftijd');
    const gewicht = getal('gewicht');
    const lengte = getal('lengte');
    const factor = Number(form.elements.activiteit.value);
    const vrouw = form.elements.geslacht.value === 'vrouw';

    const binnen = (waarde, min, max) => Number.isFinite(waarde) && waarde >= min && waarde <= max;
    if (!binnen(leeftijd, 14, 120) || !binnen(gewicht, 30, 300) || !binnen(lengte, 120, 250)) {
      fout.textContent =
        'Vul een leeftijd van 14 tot 120 jaar, een gewicht van 30 tot 300 kg en een lengte van 120 tot 250 cm in.';
      fout.hidden = false;
      form.querySelector('[data-tdee-bmr]').textContent = '—';
      form.querySelector('[data-tdee-tdee]').textContent = '—';
      return;
    }
    fout.hidden = true;

    const bmr = vrouw
      ? 447.593 + 9.247 * gewicht + 3.098 * lengte - 4.33 * leeftijd
      : 88.362 + 13.397 * gewicht + 4.799 * lengte - 5.677 * leeftijd;

    const nl = new Intl.NumberFormat('nl-NL');
    form.querySelector('[data-tdee-bmr]').textContent = nl.format(Math.round(bmr));
    form.querySelector('[data-tdee-tdee]').textContent = nl.format(Math.round(bmr * factor));
  });

  } catch(e) { console.error(e); }
})();
})();
